// ======================================================================
// File Name       : ContentNotificationSearchInput
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// =======================================================================
import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import PaginationCustom from '../Pagination';
import FormControlValidate from '../../components/FormControlValidate';
import { MODE, VALIDATE_TYPE } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';

class ContentNotificationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      handleChange,
      mode,
      notifyMessageSetSecernId,
      notifyMessageSetName,
      handleSearchMessage,
      onRegistUpdateButtonClick,
    } = this.props;
    this.refsToValidate = [];
    const isEditMode = mode === MODE.EDIT_MODE;
    const isNewMode = mode === MODE.NEW_MODE;
    const headerText = isNewMode || isEditMode ? '登録する内容を指定してください' : '検索する項目を指定してください';
    return (
      <div>
        <h3 className="margin-bottom-10">{headerText}</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            if (handleSearchMessage) {
              handleSearchMessage();
            } else {
              onRegistUpdateButtonClick();
            }
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="margin-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                通知メッセージ識別ID
              </Col>
              <Col sm={7}>
                {!isEditMode && (
                  <FormControlValidate
                    type="text"
                    name="notifyMessageSetSecernId"
                    maxLength="64"
                    label="通知メッセージ識別ID"
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    validateType={VALIDATE_TYPE.ID}
                    onChange={handleChange}
                    value={notifyMessageSetSecernId}
                    messageError={MessageTemplate.MSG_ID_INVALID}
                    messageSuccess={MessageTemplate.MSG_ID_VALID}
                  />
                )}
                {isEditMode && <Col className="padding-top-8">{notifyMessageSetSecernId}</Col>}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                通知メッセージ名{(isEditMode || isNewMode) && <span className="required">&nbsp;(※)</span>}
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  type="text"
                  label="通知メッセージ名"
                  name="notifyMessageSetName"
                  value={notifyMessageSetName}
                  onChange={handleChange}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required={isEditMode || isNewMode}
                />
              </Col>
            </Form.Group>
            <input type="submit" hidden="true" />
          </Col>
        </Form>
      </div>
    );
  }
}
export default ContentNotificationSearchInput;
